import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export const hum = () =>
    (source: Observable<any>) =>
        source
            .pipe(
                // tslint:disable-next-line: no-console
                tap(console.log, console.error)
            );
